export default "/WebApp/dist/assets/svg/actiondelete.svg";